import React, { Component } from 'react'
import { gql, graphql } from 'react-apollo'
import { connect } from 'react-redux'
import Auth from 'store/Auth'
import _ from 'lodash'
import t from 'prop-types'

import {
  Grid,
  Modal,
  Form,
} from 'components/UI'

const formFields = [
  { label: 'First Name', key: 'givenName' },
  { label: 'Last Name', key: 'familyName' },
  { label: 'Email', key: 'email' },
  { label: 'Phone Number', key: 'phoneNumber' },
]

class ProfileEdit extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: false,
      // Initialize field values from provided props
      ...props.info,
    }
  }

  close = () => {
    this.setState({
      isOpen: false,
    })
  }

  open = () => {
    this.setState({
      isOpen: true,
    })
  }

  handleChange (key, value) {
    this.setState({
      [key]: value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const attributes = _.pick(this.state, _.map(formFields, 'key'))

    this.props.submit(attributes)
    .then(() => this.props.update(attributes))
    .then(this.close)
  }

  render () {
    return (
      <div>
        <Form.Button onClick={this.open}>Edit</Form.Button>
        <Modal
          open={this.state.isOpen}
          onBlur={this.close}
          width={600}
        >
          <form onSubmit={this.handleSubmit}>
            <Grid.Row>
              <Grid.Col width={2}>
                { formFields.map(field => (
                  <Form.Text
                    key={field.key}
                    label={field.label}
                    value={this.state[field.key]}
                    onChange={value => this.handleChange(field.key, value)}
                  />
                ))}
              </Grid.Col>
              <Grid.Col>
                <Form.Button
                  onClick={this.close}
                  type='button'
                >
                  Cancel
                </Form.Button>
                <Form.Button>Save</Form.Button>
              </Grid.Col>
            </Grid.Row>
          </form>
        </Modal>
      </div>
    )
  }
}

ProfileEdit.propTypes = {
  info: t.object.isRequired,
}

const ProfileEditMutation = gql`
  mutation ProfileEditMutation(
    $givenName: String,
    $familyName: String,
    $phoneNumber: String,
  ) {
    updateManager(
      givenName: $givenName,
      familyName: $familyName,
      phone: $phoneNumber
    ) {
      id
    }
  }
`

const mapDispatchToProps = dispatch => ({
  update: details => dispatch(Auth.updateCurrentUser(details)),
})

export default graphql(ProfileEditMutation, {
  props: ({ mutate }) => ({
    submit: (variables) => mutate({ variables }),
  }),
})(connect(null, mapDispatchToProps)(ProfileEdit))



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileEdit.jsx